import howToImg from "../../../public/static/images/svg/offline_product_howto.svg";
import tncImg from "../../../public/static/images/svg/offline_product_tnc.svg";

import { DataOffline } from "../../data/DataProcedure";
import { StepsComponent } from "../UserInterface/StepsComponent";
import { TncComponent } from "../UserInterface/StepsComponent";

const ShopOfflineTerms = () => {
  const OfflineHowTo = DataOffline.howTo;
  const OfflineTnc = DataOffline.tnc;
  return (
    <div className="offline-products-terms-wrapper">
      <div className="offline-products-container">
        <StepsComponent
          img={howToImg}
          title={OfflineHowTo.title}
          steps={OfflineHowTo.steps}
        />
        <TncComponent
          title={OfflineTnc.title}
          steps={OfflineTnc.steps}
          img={tncImg}
        />
      </div>
    </div>
  );
};

export default ShopOfflineTerms;
